
import 'quill/dist/quill.snow.css'
import Quill from 'quill'

Quill.prototype.getHtml = function() {
    return this.root.innerHTML
}
